// extracted by mini-css-extract-plugin
export default {"transactions":"transactions_transactions__VYBjw","transactionWelCard":"transactions_transactionWelCard__Vy3fL","transactionTableCard":"transactions_transactionTableCard__wF0eT"};